import angular from 'angular';

angular.module('AaApp.Opp').constant('defaultCashTermMonths', 60);
